import { render, staticRenderFns } from "./TopicSelector.vue?vue&type=template&id=01fa5971&scoped=true&"
import script from "./TopicSelector.vue?vue&type=script&lang=js&"
export * from "./TopicSelector.vue?vue&type=script&lang=js&"
import style0 from "./TopicSelector.vue?vue&type=style&index=0&id=01fa5971&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fa5971",
  null
  
)

export default component.exports